
import { AxiosError, AxiosResponse } from 'axios';
import { DetailedCartItem } from 'hooks/context/cart';
import { isAxiosError } from 'util/axiosHelpers';

const GENERIC_ERROR_TEXT = 'generic';

type AnyError = any | string | AxiosError | AxiosResponse | undefined;

export const parseErrorMessage = (error: AnyError) => {
  if (!error) return GENERIC_ERROR_TEXT;
  if (typeof error === 'string') return error;

  const errorResponse = isAxiosError(error) ? error.response : error;

  if (typeof errorResponse?.data === 'string') return errorResponse.data;

  if (typeof errorResponse?.data?.message === 'string') return errorResponse.data.message;

  return GENERIC_ERROR_TEXT;
};

export const parseErrorType = (error: AnyError) => {
  const errorResponse = isAxiosError(error) ? error.response : error;

  return errorResponse?.status;
};

export const GYFT_ERROR_CODE = 'checkoutPage.errorMessages.giftCardFailed';
export const GYFT_ERROR_WITH_ITEMS = 'checkoutPage.errorMessages.giftCardFailedWithItems';
export const GIFT_CARD_ERROR = 'checkoutPage.errorMessages.fourXXError';

export const getI18nKeyFromError = (error: AnyError, cartItems: DetailedCartItem[] = []) => {
  const i18nKeyBase = 'checkoutPage.errorMessages.';
  const errMsg = parseErrorMessage(error).toLowerCase();
  if (errMsg.indexOf('gyft api') > -1) {
    return cartItems.length > 0 ? GYFT_ERROR_WITH_ITEMS : GYFT_ERROR_CODE;
  }
  if (errMsg.indexOf('declined') > -1) return `${i18nKeyBase}cardDeclined`;
  if (errMsg.indexOf('expired') > -1) return `${i18nKeyBase}cardExpired`;
  if (errMsg.indexOf('restricted card') > -1) return `${i18nKeyBase}cardTypeNotAllowed`;
  if (errMsg.indexOf('out of range') > -1) return `${i18nKeyBase}schedulingError`;
  if (errMsg.indexOf('maintenance') > -1) return `${i18nKeyBase}sorryMaintenance`;
  if (errMsg.indexOf('invalid input') > -1) return `${i18nKeyBase}invalidInput`;
  if (errMsg.indexOf('cvv') > -1 || errMsg.indexOf('postal') > -1) return `${i18nKeyBase}cardDetailFraudPrevention`;
  if (errMsg.indexOf('order total must be greater than 0') > -1) return `${i18nKeyBase}orderTotalMustBeGreaterThanZero`;
  if (errMsg.indexOf('paid order') > -1) return `${i18nKeyBase}alreadyPaid`;
  if (errMsg.indexOf('item_not_available') > -1) return `${i18nKeyBase}eightySixth`;

  return `${i18nKeyBase}genericError`;
};

export const reCaptchaReadyLogger = (isReCaptchaReady: boolean) => {
  if (!isReCaptchaReady) {
    if (process.env.NODE_ENV === 'development') console.error('reached submit before recaptcha ready');
  }
};
